"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("../../TextField"));
var Loader_1 = __importDefault(require("./Loader"));
var Input = function (props) {
    var _a, _b, _c;
    var params = props.params, inputProps = props.inputProps, isLoading = props.isLoading, showTextFieldEndAdornment = props.showTextFieldEndAdornment;
    return (react_1.default.createElement(TextField_1.default, __assign({}, params, { variant: "standard" }, inputProps, { InputLabelProps: __assign({}, params.InputLabelProps || {}), InputProps: __assign(__assign(__assign(__assign({}, params.InputProps), ((inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps) || {})), (((_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps) === null || _a === void 0 ? void 0 : _a.startAdornment)
            || params.InputProps.startAdornment) && {
            startAdornment: (react_1.default.createElement(react_1.default.Fragment, null, (_b = inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps) === null || _b === void 0 ? void 0 :
                _b.startAdornment,
                params.InputProps.startAdornment))
        }), { endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Loader_1.default, { isLoading: isLoading }),
                showTextFieldEndAdornment && params.InputProps.endAdornment, (_c = inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps) === null || _c === void 0 ? void 0 :
                _c.endAdornment)) }) })));
};
exports.default = Input;
